import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { SCHEDULE_REPOSITORY, ScheduleRepository } from '@app/domain/repositories/mot/schedule.repository.contract';
import { ErrorMsgEnum } from '@app/entities/enums/error/error-msg-enum';
import { MomoSchedule } from '@app/entities/models/mot/schedule/momo-schedule.model';
import { Schedule, ScheduleObservations } from '@app/entities/models/mot/schedule/schedule.model';

import { ScheduleUseCases } from './schedule.use-cases.contract';

@Injectable({
  providedIn: 'root'
})
export class ScheduleUseCasesImpl implements ScheduleUseCases {
  #scheduleRepository: ScheduleRepository = inject(SCHEDULE_REPOSITORY);

  getSchedule(): Observable<Schedule> {
    return this.#scheduleRepository.getSchedule();
  }

  getMomoSchedule(): Observable<MomoSchedule> {
    return this.#scheduleRepository.getMomoSchedule();
  }

  getMonthlyObservations(year: string, month: string): Observable<ScheduleObservations> {
    return this.#scheduleRepository.getMonthlyObservations(year, month);
  }

  onError(): Observable<ErrorMsgEnum> {
    return this.#scheduleRepository.onError$;
  }
}
